import { IconButton, styled } from '@mui/material'

const StyledArrowIconButton = styled(IconButton)(() => ({
  width: 28,
  height: 28,
}))

export default StyledArrowIconButton
